module.exports = __webpack_public_path__ + "img/certificate-4.c3c66ff2.png";